import { createFileRoute, useParams } from '@tanstack/react-router';

import { ExerciseDetailScreen } from '@/features/exercises/components/ExerciseDetailScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/exercises/$id')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: ClinicalExerciseDetailRoute,
  staticData: { crumb: 'Exercise' },
});

function ClinicalExerciseDetailRoute() {
  const { id } = useParams({ from: '/app/exercises/$id' });
  return <ExerciseDetailScreen id={id} surface="clinical" />;
}
